import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment-timezone';

interface IMoodtrackerFormatedData {
	date: string;
	dayOfWeek: string;
	entries: [];
}

@Component({
	selector: 'moodtracker-report-card',
	templateUrl: './moodtracker-report-card.component.html',
	styleUrls: ['moodtracker-report-card.component.scss'],
})
export class MoodTrackerReportCardComponent implements OnInit {
	@Input() data;

	constructor(public translateService: TranslateService) {}

	public formatedData: IMoodtrackerFormatedData = null;

	ngOnInit(): void {
		this.formatedData = this.formatData();
	}

	formatData() {
		return {
			date: moment(this.data.date).format('DD/MM/yyyy'),
			dayOfWeek: this.translateService.instant(
				'CALENDAR.WEEKDAYS.' +
					moment(this.data.date).format('ddd').toUpperCase() +
					'.FULL'
			),
			entries: this.data.entries.map((entry) => {
				return {
					...entry,
					time: `${moment(entry.createdDate).format('k')}h${moment(
						entry.createdDate
					).format('mm')}`,
				};
			}),
		};
	}
}
